
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import DoneIcon from '@mui/icons-material/Done'
import ErrorIcon from '@mui/icons-material/Close'
import Spinner from 'react-md-spinner'
import moment from 'moment'
import { themeV5 } from 'theme/v5'

// used in Vehicle Relocations Summary, Vehicle Relief Summary, RUC Requests Summary
const RegistrationLookupWrapper = ({ children, lookupContractData, fetchContractStatus, lookupContractErrorMessage, checkMaturityDate = true }) => {

  const lookupContractError = fetchContractStatus === 'error'
  const lookupContractLoading = fetchContractStatus === 'processing'

  const hasContract = !!lookupContractData?.agreementNo
  const expiredMaturityDate = checkMaturityDate
    && lookupContractData?.maturityDate
    && moment(lookupContractData?.maturityDate) <= moment()

  return (
    <Grid container spacing={4}>

      <Grid item sm={6} xs={12}
        sx={{
          paddingTop: '32px',
          paddingLeft: '32px'
        }}>
        {children}
      </Grid>

      <Grid item sm={6} xs={12}
        sx={{
          paddingTop: '32px',
          paddingLeft: '32px'
        }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            height: '100%',
          }}>
          {lookupContractError && (
            <>
              <ErrorIcon
                sx={{
                  marginRight: 1,
                  color: themeV5.palette.error.main,
                }}
                size={30} />
              <Typography
                sx={{
                  color: themeV5.palette.error.main
                }}
                variant="bodyLarge">
                {lookupContractErrorMessage || 'We could not find a matching contract for this registration'}
              </Typography>
            </>
          )}

          {lookupContractLoading && (
            <>
              <Spinner
                sx={{
                  marginRight: 1,
                }}
                singleColor={themeV5.palette.dark}
                size={18} />
              <Typography
                sx={{
                  marginRight: 1,
                }}
                variant="bodyLarge">
                Loading contract
              </Typography>
            </>
          )}

          {hasContract && ! lookupContractLoading && ! expiredMaturityDate && (
            <DoneIcon
              sx={{
                marginRight: 1,
                color: '#66BB6A',
              }}
              size={30} />
          )}
          {hasContract && ! lookupContractLoading && expiredMaturityDate && (
            <>
              <ErrorIcon
                sx={{
                  marginRight: 1,
                  color: themeV5.palette.error.main,
                }}
                size={30} />
              <Typography
                sx={{
                  color: themeV5.palette.error.main
                }}
                variant="bodyLarge">
                Sorry, the maturity date for this vehicle has expired.
                You cannot make any bookings for this vehicle. Please try a different registration.
              </Typography>
            </>
          )}
        </Box>
      </Grid>
    </Grid>
  )
}

RegistrationLookupWrapper.propTypes = {
  children: PropTypes.any,
  lookupContractData: PropTypes.object.isRequired,
  fetchContractStatus: PropTypes.string.isRequired,
  lookupContractErrorMessage: PropTypes.string,
  checkMaturityDate: PropTypes.bool,
}

export default RegistrationLookupWrapper
